// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PERITADOR_CLEAN_STATE } from './constants'

export function cleanState() {
  return {
    type: PERITADOR_CLEAN_STATE,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_CLEAN_STATE:
      return {
        ...state,
        verification: null,
      }

    default:
      return state
  }
}
